/// <amd-module name="Artifacts/Connect/types/ICombinedFeedView" />
import { UpstreamSourceIdentifier, ViewIdentifier } from "Artifacts/Root/types/AzureArtifacts";
import { IFeed } from "Artifacts/Root/types/IFeed";
import { FeedRole, ProjectReference } from "Artifacts/Root/web-apis/contracts/Feed";

export interface ICombinedFeedView {
  readonly id: string;
  readonly name: string;
  readonly role: FeedRole;
  readonly project: ProjectReference | undefined;
  readonly upstreamSources: UpstreamSourceIdentifier[];

  /**
   * If set, the user can publish packages to this feed
   */
  readonly canPublishPackages: boolean;
}

export class CombinedFeedView implements ICombinedFeedView {
  id: string;
  name: string;
  role: FeedRole;
  project: ProjectReference | undefined;
  upstreamSources: UpstreamSourceIdentifier[];
  canPublishPackages: boolean;

  constructor(feed: IFeed, view?: ViewIdentifier) {
    let fromView = false;
    if (view !== undefined) {
      this.id = feed.id + "@" + view.id;
      this.name = feed.name + "@" + view.name;
      fromView = true;
    } else {
      this.id = feed.id;
      this.name = feed.name;
    }

    this.project = feed.project;
    this.role =
      feed.permissions && feed.permissions?.length > 0 ? feed.permissions[0].role : FeedRole.None;

    this.upstreamSources = feed.upstreamSources;

    this.canPublishPackages =
      fromView !== true &&
      (this.role === FeedRole.Administrator || this.role === FeedRole.Contributor);
  }
}
